




















import { Component, Prop, Vue } from 'vue-property-decorator';
import FontPicker from '@/components/FontPicker/index.vue';
import PopField from '../PopField/index.vue';
import { fontFaceList } from '@/views/wheelOfFortune/constant/options';

/**
 * 字体字段。mode=picker 对应 FontPicker（enableFormOptimize 新分支），
 * mode=select 对应 el-select+fontFaceList 旧分支；两态并存是灰度现状，不得只留一态。
 * 注意：FontPicker 的 @Model 是 change 禁用、value+input 标准 v-model（源码 L133-136），
 * 且内部 normalize 后会自回写 input+change（L336-348），两个事件都必须透传。
 */
@Component({ components: { PopField, 'font-picker': FontPicker } })
export default class FontField extends Vue {
  @Prop({ type: String, default: '' }) value!: string;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, default: '' }) col!: string;
  @Prop({ type: String, default: 'picker' }) mode!: 'picker' | 'select';
  @Prop({ type: Boolean, default: false }) showAddButton!: boolean;
  fontFaceList = fontFaceList;
}
